import { useQuery } from "@tanstack/react-query";
import { REPORTS } from "@/data/mock";
import { withLatency } from "./simulate";

export async function fetchReports() {
  return withLatency(REPORTS);
}

export function useReports() {
  return useQuery({ queryKey: ["reports"], queryFn: fetchReports, staleTime: 60_000 });
}
